(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3373],{

/***/ 43373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ components_BestStack_BestStack; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
// EXTERNAL MODULE: ../../libs/matcha/components/Elevation/index.ts + 2 modules
var Elevation = __webpack_require__(33606);
// EXTERNAL MODULE: ./src/views/Product/LandingPage/components/BestStack/assets/BestStack@2x.png
var BestStack_2x = __webpack_require__(49325);
var BestStack_2x_default = /*#__PURE__*/__webpack_require__.n(BestStack_2x);
// EXTERNAL MODULE: ./src/views/Product/LandingPage/components/BestStack/assets/BestStack.webp
var BestStack = __webpack_require__(23849);
var BestStack_default = /*#__PURE__*/__webpack_require__.n(BestStack);
// EXTERNAL MODULE: ./src/views/Product/LandingPage/components/BestStack/assets/BestStack@2x.webp
var assets_BestStack_2x = __webpack_require__(51360);
var assets_BestStack_2x_default = /*#__PURE__*/__webpack_require__.n(assets_BestStack_2x);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/Product/LandingPage/components/BestStack/BestStackImage.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var BestStackImage = function BestStackImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledElevation, {
    elevation: 4,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
        type: "image/webp",
        srcSet: "".concat((BestStack_default()), ", ").concat((assets_BestStack_2x_default()), " 2x")
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
        width: "639",
        height: "515",
        src: (BestStack_2x_default()),
        alt: "Launch with the best stack",
        loading: "lazy"
      })]
    })
  });
};

var StyledElevation = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Elevation/* default */.Z,  true ? {
  target: "en14jsa0"
} : 0)( true ? {
  name: "arfe1i",
  styles: "border-radius:8px"
} : 0);

/* harmony default export */ var BestStack_BestStackImage = (BestStackImage);
;// CONCATENATED MODULE: ./src/views/Product/LandingPage/components/BestStack/BestStack.tsx


function BestStack_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var copy = {
  overline: "Segment for Product Teams",
  heading: "Launch with the right stack",
  description: "Enable the best product analytics tools, A/B testing tools, and data warehousing tools with the flip of a switch."
};
var BestStack_link = {
  text: "Explore Connections",
  url: "https://segment.com/docs/connections/sources/"
};

var BestStack_BestStack = function BestStack() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledSectionBase, {
      variant: "2Col",
      reverse: true,
      copyVariant: "narrow",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BestStack_BestStackImage, {})
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionCopy, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
            children: copy.overline
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            variant: "h2",
            tag: "h2",
            children: copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            tag: "p",
            variant: "pLarge",
            children: copy.description
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkWrapper, {
            size: "medium",
            tag: "a",
            href: BestStack_link.url,
            iconEnd: Common/* ChevronRightIcon */.XC,
            children: BestStack_link.text
          })]
        })
      })]
    })
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "e5ufmfo3"
} : 0)( true ? "" : 0);

var StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e5ufmfo2"
} : 0)( true ? {
  name: "1h8nup8",
  styles: "overflow:visible"
} : 0);

var StyledSectionCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "e5ufmfo1"
} : 0)("align-self:center;direction:initial;justify-self:end;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("lg");
}, "{max-width:440px;}" + ( true ? "" : 0));

var LinkWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ButtonText/* default */.Z,  true ? {
  target: "e5ufmfo0"
} : 0)( true ? {
  name: "1n8met0",
  styles: "padding-top:0"
} : 0);

/* harmony default export */ var components_BestStack_BestStack = (BestStack_BestStack);
;// CONCATENATED MODULE: ./src/views/Product/LandingPage/components/BestStack/index.ts


/***/ }),

/***/ 49325:
/***/ (function(module) {

module.exports = "/_next/static/images/BestStack@2x-cdbe58b0a672f32627baeac3a0762562.png";

/***/ }),

/***/ 23849:
/***/ (function(module) {

module.exports = "/_next/static/images/BestStack-aba99bbfdb829c906d0052136532fca2.webp";

/***/ }),

/***/ 51360:
/***/ (function(module) {

module.exports = "/_next/static/images/BestStack@2x-cdbe58b0a672f32627baeac3a0762562.webp";

/***/ })

}]);